import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../store/hooks';
import { getSiteLocaleFromPathname, withSiteLocale } from '../../utils/helpers';
import { googleAuth } from '../../api/auth';
import { getCurrentUser } from '../../store/auth/authSlice';

import './googleAuthButton.css';

export function GoogleAuthButton() {
    const navigate = useLocalizedNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const locale = getSiteLocaleFromPathname(location.pathname);

    const onSuccess = async (res: CredentialResponse) => {
        if (!res.credential) return;

        const result = await googleAuth(res.credential);

        if (result.needsProfile) {
            const missing = result.missing || []; // e.g. ['name', 'surname', 'countryCode', 'city']
            sessionStorage.setItem(
                'missingProfileFields',
                JSON.stringify(missing)
            );

            navigate(withSiteLocale('/complete-profile', locale), {
                state: { missing },
            });
            return;
        }

        await dispatch(getCurrentUser());
        navigate('/home', { replace: true });
    };

    return (
        <div className="google-wrap">
            <GoogleLogin
                onSuccess={onSuccess}
                onError={() => console.error('Google Login Failed')}
                theme="outline"
                size="large"
                shape="rectangular"
                text="signin_with"
                logo_alignment="center"
                width={300}
            />
        </div>
    );
}
